module.exports = __webpack_public_path__ + "static/makers-and-takers-62bc98695c161de23229a0893ab40272.jpg";